import React, { PureComponent } from 'react'
import styles from './FavoriteButton.scss'
import LottieSVG from '@components/LottieSVG'
import TopicList from '@components/FavoriteButton/TopicList'
import Drawer from '@material-ui/core/Drawer'
import FasStar from '@components/Icons/font-awesome/FasStar'
import FarStar from '@components/Icons/font-awesome/FarStar'
import { compose, withBeacon, withTranslation } from '@hocs'

class FavoriteButton extends PureComponent {
  static defaultProps = {
    onClickFavorite: () => Promise.resolve(),
  }

  state = {
    savedLottieDisplay: false,
    isOpenDrawer: false,
    savedNum: 0,
  }
  componentDidMount() {
    const { savedNum } = this.props
    this.setState({ savedNum })
    this._isShowAnimation = false //不是點擊star的狀況，不需要顯示動畫
  }
  componentDidUpdate(prevProps) {
    const { isSaved } = this.props
    const { savedNum } = this.state
    if (isSaved !== prevProps.isSaved) {
      if (isSaved) {
        this.setState({
          savedNum: savedNum + 1,
          savedLottieDisplay: this._isShowAnimation,
        })
      } else {
        this.setState({ savedNum: savedNum - 1 })
      }
    }
  }
  render() {
    const { topicList, isSaved, t, text } = this.props
    const savedNum = Math.max(this.state.savedNum, 0)
    return (
      <div
        className={`favoriteButton favoriteButton--${isSaved ? 'saved' : 'unsaved'}`}
        onClick={this._onClickFavoriteButton}
      >
        <style jsx>{styles}</style>
        <div className={`favoriteButton__icon icon icon--${isSaved ? 'saved' : 'unsaved'}`}>
          {this._renderIcon()}
        </div>
        <span className="favoriteButton__text">{text || t('收藏')}</span>
        {savedNum ? (
          <span className="favoriteButton__num">{savedNum}</span>
        ) : (
          <span className="favoriteButton__num favoriteButton__num--nodata" />
        )}
        <Drawer
          classes={{
            paper: 'topListDrawerPaper',
          }}
          anchor="bottom"
          open={this.state.isOpenDrawer}
          onClose={this._onCloseDrawer}
        >
          <TopicList
            setPostToTopic={this._setPostToTopic}
            topicList={topicList}
            onClose={this._onCloseDrawer}
            isSaved={isSaved}
          />
        </Drawer>
      </div>
    )
  }
  _renderIcon = () => {
    const { icon, isSaved } = this.props
    if (!icon) {
      if (isSaved) {
        return (
          <>
            <FasStar className="iconStar" />
            {this.state.savedLottieDisplay && (
              <LottieSVG
                wrapClassName="lottieStar"
                className="star"
                loop={false}
                autoplay={true}
                defaultStartFrame={8}
                startFromLastFrame={true}
                onComplete={this._onLottieComplete}
              />
            )}
          </>
        )
      } else {
        return <FarStar className="iconStarO" />
      }
    } else {
      return icon
    }
  }
  _onCloseDrawer = (e) => {
    e.stopPropagation()
    this.setState({ isOpenDrawer: false })
  }
  _onLottieComplete = (lottie) => {
    lottie && lottie.destroy()
    this.setState({
      savedLottieDisplay: false,
    })
  }
  _onClickFavoriteButton = async (e) => {
    try {
      e.stopPropagation()
      this._isShowAnimation = true
      const { onClickFavorite } = this.props
      await onClickFavorite()
      this.setState({ isOpenDrawer: true })
    } catch (error) {
      if (error.silent) return
      console.warn(error)
    }
  }
  _setPostToTopic = ({ topicList }) => {
    const { setPostToTopic } = this.props
    setPostToTopic({ topicList })
  }
}

export default compose(withBeacon, withTranslation(['common']))(FavoriteButton)
